import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {reportEvent} from '../helper';

class TurnOff extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isHidden: false
        };

        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        e && e.preventDefault();

        reportEvent('click_off', {
            'current_page_type': 'gigs_page',
            'seller': {
                'id': this.props.userId
            }
        });

        this.props.turnOff();
    }

    render() {
        return (
            <a href="#!" className="turn-off-link" onClick={this.onClick}>
                <i className="fa fa-briefcase" aria-hidden="true"></i> Turn Off
            </a>
        );
    }
}

TurnOff.propTypes = {
    turnOff: PropTypes.func.isRequired,
    userId: PropTypes.number.isRequired
};

TurnOff.defaultProps = {
    turnOff: () => null,
    userId: 0
};

export default TurnOff;


// WEBPACK FOOTER //
// ./src/TurnOff/TurnOff.js